import React from "react";
import styles from "./SportsmanPage.module.styl";
import SportsmanInfo from "../../../components/dashboard/SportsmanInfo/SportsmanInfo";
import { useGetSportsmanData } from "hooks/sportsmans";
import { ErrorTile, Loader } from "uikit/components";
import { useParams } from "react-router";
import SportsmanRelativeRating from "../../../components/dashboard/SportsmanRelativeRating/SportsmanRelativeRating";
import SportsmanRatingInfo from "../../../components/dashboard/SportsmanRatingInfo/SportsmanRatingInfo";
import { Link } from "react-router-dom";
import SportsmanTests from "../../../components/dashboard/SportsmanTests/SportsmanTests";
import { Helmet } from "react-helmet-async";

export default function SportsmanPage() {
    const { sportsmanId } = useParams();
    const { isLoading, isError, data } = useGetSportsmanData(sportsmanId);

    return (
        <>
            <div className={styles.linkContainer}>
                <Link
                    to={{
                        pathname: "/",
                        state: { fromSportsmanPage: true },
                    }}
                    title={"Назад к списку"}
                    className={styles.link}
                >
                    ← Назад к списку
                </Link>
            </div>
            {isLoading ? (
                <Loader size={"full"} />
            ) : isError ? (
                <ErrorTile text={""} />
            ) : (
                <>
                    <Helmet>
                        <meta
                            name="apple-mobile-web-app-title"
                            content={`Профиль спортсмена: ${data.baseSportsmanInfo.firstName} ${data.baseSportsmanInfo.lastName}`}
                        />
                        <meta
                            name="application-name"
                            content={`Профиль спортсмена: ${data.baseSportsmanInfo.firstName} ${data.baseSportsmanInfo.lastName}`}
                        />
                    </Helmet>
                    <div className={styles.container}>
                        <div className={styles.row}>
                            <SportsmanInfo sportsman={data.baseSportsmanInfo} />
                            <SportsmanRelativeRating
                                relativeRating={data.ratingRelativeToRecords}
                            />
                            <SportsmanRatingInfo ratingInfo={data.ratingInfo} />
                        </div>
                        <div className={styles.row}>
                            <SportsmanTests
                                comparisonsWithBestInRegion={data.comparisonsWithBestInRegion}
                                comparisonsWithBest={data.comparisonsWithBest}
                                comparisonsWithTestingSessionRecords={
                                    data.comparisonsWithTestingSessionRecords
                                }
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    );
}
